import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import CookieConsentBanner from './components/common/CookieConsentBanner';
import { AppRoutes } from './routes/AppRoutes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Router>
            <div className="min-h-screen bg-lp-paper">
              <ErrorBoundary>
                <AppRoutes />
              </ErrorBoundary>
              <Toaster 
              position="bottom-right"
              containerStyle={{
                zIndex: 10000,
              }}
              toastOptions={{
                duration: 6000,
                // Estilo de la landing: tarjeta clara, esquinas amplias, tipografía DM Sans
                style: {
                  background: '#ffffff',
                  color: '#1E2B28',
                  border: '1px solid rgba(30, 43, 40, 0.08)',
                  borderRadius: '18px',
                  padding: '12px 16px',
                  fontFamily: "'DM Sans', system-ui, sans-serif",
                  fontSize: '14px',
                  boxShadow: '0 20px 40px -20px rgba(30, 43, 40, 0.35)',
                  zIndex: 10000,
                },
                success: {
                  iconTheme: {
                    primary: '#1F7A6C',
                    secondary: '#ffffff',
                  },
                },
                error: {
                  iconTheme: {
                    primary: '#dc2626',
                    secondary: '#ffffff',
                  },
                  duration: 8000,
                },
              }}
            />
              <CookieConsentBanner />
            </div>
          </Router>
      </AuthProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
};

export default App;

